import { formatInstance, object2camelCase } from '@utils'
import { ClassConstructor, type TargetMap } from 'class-transformer'
import type { HTTPResponseArray, HTTPResponseRecord } from './types'

export class ResponseFormater {
  static async format<T>(
    response: Response,
    ClassCtor?: ClassConstructor<T>,
    targetMaps?: TargetMap[]
  ): Promise<HTTPResponseRecord<T>> {
    const data = object2camelCase(await response.json())
    if (ClassCtor) {
      return formatInstance<T>(ClassCtor, targetMaps)(data) as HTTPResponseRecord<T>
    }

    return data as HTTPResponseRecord<T>
  }

  static async formatArray<T>(
    response: Response,
    ClassCtor?: ClassConstructor<T>,
    targetMaps?: TargetMap[]
  ): Promise<ResponseArray<T>> {
    const data = object2camelCase(await response.json())
    const list = ClassCtor ? formatInstance<T>(ClassCtor, targetMaps)(data.data) : data.data
    return new ResponseArray<T>(list, data.total)
  }

  static async formatError(error: Response) {
    const data = await error.json()
    return Promise.reject(data)
  }
}

export class ResponseArray<T> implements HTTPResponseArray<T> {
  data: T[]
  total: number
  constructor(data: any[], total?: number | string) {
    this.data = data
    this.total = total ? Number(total) : 0
  }
}
